"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _EditorControls = _interopRequireDefault(require("./EditorControls"));

var _ImageEditor = _interopRequireDefault(require("../../../blocks/ImageEditor"));

var _ProfileImage = _interopRequireDefault(require("../../../elements/ProfileImage"));

var _Button = _interopRequireDefault(require("../../../elements/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ViewImage extends _react.default.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "fileInputRef", _react.default.createRef());

    _defineProperty(this, "_choosePhotoHandler", e => {
      e.preventDefault();
      this.fileInputRef.current.click();
    });
  }

  render() {
    const _this$props = this.props,
          _handlePhotoChange = _this$props._handlePhotoChange,
          imgSrc = _this$props.imgSrc;
    return /*#__PURE__*/_react.default.createElement(_ImageEditor.default, null, /*#__PURE__*/_react.default.createElement(_ImageEditor.default.Image, null, /*#__PURE__*/_react.default.createElement(_ProfileImage.default, {
      src: imgSrc
    })), /*#__PURE__*/_react.default.createElement(_EditorControls.default, null, /*#__PURE__*/_react.default.createElement("input", {
      hidden: true,
      onChange: _handlePhotoChange,
      ref: this.fileInputRef,
      type: "file"
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      modifiers: ['primary', 'small'],
      onClick: this._choosePhotoHandler
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "ViewImage.choosePhotoBtn",
      defaultMessage: "Choose Photo"
    }))));
  }

}

ViewImage.propTypes = {
  _handlePhotoChange: _propTypes.default.func.isRequired,
  imgSrc: _propTypes.default.string.isRequired
};
var _default = ViewImage;
exports.default = _default;